import { createSlice } from "@reduxjs/toolkit";
import { splitCorrelationId } from "../Services/CommonServices";

const initialState = {
  errorCode: null,
  errorNumber: null,
  showErrorModal: false,
};
export const errorBoundaryStrategySlice = createSlice({
  name: "errorBoundary",
  initialState,
  reducers: {
    updateError: (state, action) => {
      const error = action.payload;
      const correlationIdArray = splitCorrelationId(
        8,
        error?.response?.data?.correlationId
      );
      state.errorCode = correlationIdArray[0];
      state.errorNumber = correlationIdArray[1];
      if (state.errorCode || state.errorNumber) {
        state.showErrorModal = true;
      }
    },
    resetError: (state) => {
      state.showErrorModal = false;
      state.errorCode = null;
      state.errorNumber = null;
    },
  },
});

export const { updateError, resetError } = errorBoundaryStrategySlice.actions;

export default errorBoundaryStrategySlice.reducer;
